export default "__VITE_ASSET__Cu6T2EY0__"